"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = exports.defaultHost = void 0;

var grpc_web_1 = require("@improbable-eng/grpc-web");

var security_1 = require("@textile/security");

exports.defaultHost = "https://webapi.hub.textile.io";
/**
 * Context provides context management for gRPC credentials and config settings.
 * It is the default implementation for the ContextInterface interface.
 */

var Context = /*#__PURE__*/function () {
  /**
   * Construct a new Context object.
   * @param host The remote gRPC host. This input exists to comply with the Config interface.
   */
  function Context() {
    var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.defaultHost;

    _classCallCheck(this, Context);

    // Internal context variables
    this._context = {};
    this._context["host"] = host;
  }

  _createClass(Context, [{
    key: "set",
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    value: function set(key, value) {
      this._context[key] = value;
      return this;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._context[key];
    }
  }, {
    key: "withSession",
    value: function withSession(value) {
      if (value === undefined) return this;
      this._context["x-textile-session"] = value;
      return this;
    }
  }, {
    key: "withThread",
    value: function withThread(value) {
      if (value === undefined) return this;
      this._context["x-textile-thread"] = value.toString();
      return this;
    }
  }, {
    key: "withThreadName",
    value: function withThreadName(value) {
      if (value === undefined) return this;
      this._context["x-textile-thread-name"] = value;
      return this;
    }
  }, {
    key: "withOrg",
    value: function withOrg(value) {
      if (value === undefined) return this;
      this._context["x-textile-org"] = value;
      return this;
    }
  }, {
    key: "withToken",
    value: function withToken(value) {
      if (value === undefined) return this;
      this._context["authorization"] = "bearer ".concat(value);
      return this;
    }
  }, {
    key: "withAPIKey",
    value: function withAPIKey(value) {
      if (value === undefined) return this;
      this._context["x-textile-api-key"] = value;
      return this;
    }
  }, {
    key: "withAPISig",
    value: function withAPISig(value) {
      if (value === undefined) return this;
      var sig = value.sig,
          msg = value.msg;
      this._context["x-textile-api-sig-msg"] = msg;
      this._context["x-textile-api-sig"] = sig;
      return this;
    }
  }, {
    key: "withKeyInfo",
    value: function withKeyInfo(key, date) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sig;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(key === undefined)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this);

              case 2:
                if (key.secret) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.withAPIKey(key.key));

              case 4:
                _context.next = 6;
                return security_1.createAPISig(key.secret, date);

              case 6:
                sig = _context.sent;
                return _context.abrupt("return", this.withAPIKey(key.key).withAPISig(sig));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "withContext",
    value: function withContext(value) {
      if (value === undefined) return this; // Spread to copy rather than reference

      this._context = value.toJSON();
      return this;
    }
    /**
     * Returns true if this Context contains an api sig msg, and that msg has expired, or if
     * it does _not_ have an api sig msg, but it _does_ have an auth callback.
     */

  }, {
    key: "refreshUserAuth",

    /**
     * Refresh user auth with provided callback.
     * If callback is not specified, attempts to use existing callback specified at initialization.
     */
    value: function refreshUserAuth(authCallback) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _a, key, token, sig;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // If we have a new one, use it...
                if (authCallback !== undefined) {
                  this.authCallback = authCallback;
                } // If we still don't have a callback, throw...


                if (!(this.authCallback === undefined)) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("Missing authCallback. See Context.fromUserAuthCallback for details.");

              case 3:
                _context2.next = 5;
                return this.authCallback();

              case 5:
                _a = _context2.sent;
                key = _a.key;
                token = _a.token;
                sig = __rest(_a, ["key", "token"]);
                return _context2.abrupt("return", this.withAPIKey(key).withAPISig(sig).withToken(token));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Convert Context to plain JSON object.
     * @throws If this Context has expired.
     * @see toMetadata for an alternative for gRPC clients that supports auto-renewal.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = __rest(this._context // If we're expired, throw...
      , []); // If we're expired, throw...


      if (this.isExpired) {
        throw security_1.expirationError;
      }

      return json;
    }
    /**
     * Convert Context to grpc Metadata object.
     * Will automatically call the auth callback if available.
     * @param ctx Additional context object that will be merged with this prior to conversion.
     * @see toJSON for an alternative that returns a plain object, and throws when expired.
     */

  }, {
    key: "toMetadata",
    value: function toMetadata(ctx) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var context, _a, key, token, sig;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = new Context();

                if (!(this.isExpired && this.authCallback !== undefined)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 4;
                return this.authCallback();

              case 4:
                _a = _context3.sent;
                key = _a.key;
                token = _a.token;
                sig = __rest(_a, ["key", "token"]);
                // We do want to mutate this here because we want to update our auth sig
                this.withAPIKey(key).withAPISig(sig).withToken(token);

              case 9:
                return _context3.abrupt("return", new grpc_web_1.grpc.Metadata(context.withContext(this).withContext(ctx).toJSON()));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Import various ContextInterface API properties from JSON.
     * @param json The JSON object.
     * @param host Optional host string.
     */

  }, {
    key: "host",
    get: function get() {
      return this._context["host"];
    }
  }, {
    key: "isExpired",
    get: function get() {
      var msg = this.get("x-textile-api-sig-msg");
      var notAuthed = msg === undefined && this.authCallback !== undefined;
      var isExpired = msg !== undefined && new Date(msg) <= new Date();
      return isExpired || notAuthed;
    }
  }], [{
    key: "fromUserAuth",
    value: function fromUserAuth(auth) {
      var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.defaultHost;
      var ctx = new Context(host);

      var key = auth.key,
          token = auth.token,
          sig = __rest(auth, ["key", "token"]);

      return ctx.withAPIKey(key).withAPISig(sig).withToken(token);
    }
  }, {
    key: "fromUserAuthCallback",
    value: function fromUserAuthCallback(authCallback) {
      var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.defaultHost;
      var ctx = new Context(host); // @todo: Should we now callback right away?

      ctx.authCallback = authCallback;
      return ctx;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.defaultHost;
      var newContext = Object.assign({}, json);
      newContext["host"] = host;
      var ctx = new Context();
      ctx._context = newContext;
      return ctx;
    }
  }]);

  return Context;
}();

exports.Context = Context;